import api from './api';
import { AxiosResponse } from 'axios';

export interface PropertyRecommendation {
  id: number;
  name: string;
  property_id: string;
  occupancy_rate: number;
  availability: {
    available_rooms: number;
    total_rooms: number;
    percentage: number;
  };
  recommendation_score: number;
}

export interface PropertyRecommendationFilter {
  start_date?: string;
  end_date?: string;
  guest_count?: number;
  preferred_location?: string;
}

export interface SendRecommendationRequest {
  reservation_id: number;
  recommended_property_id: number;
  message?: string;
}

export interface Property {
  id: number;
  name: string;
  property_id: string;
  address: string;
  city: string;
  state: string;
  country: string;
}

const propertyService = {
  // Get property recommendations with filters
  getPropertyRecommendations: async (filters: PropertyRecommendationFilter = {}): Promise<PropertyRecommendation[]> => {
    try {
      console.log('Fetching property recommendations with filters:', filters);
      
      const params = new URLSearchParams();
      if (filters.start_date) params.append('start_date', filters.start_date);
      if (filters.end_date) params.append('end_date', filters.end_date);
      if (filters.guest_count) params.append('guest_count', filters.guest_count.toString());
      if (filters.preferred_location) params.append('preferred_location', filters.preferred_location);
      
      const response: AxiosResponse = await api.get(`/api/property-recommendations/?${params.toString()}`);
      console.log('Property recommendations response:', response.data);
      
      if (!response.data.data?.recommendations) {
        console.error('Invalid response format:', response.data);
        throw new Error('Invalid property recommendations response format from API');
      }
      
      return response.data.data.recommendations;
    } catch (error) {
      console.error('Error fetching property recommendations:', error);
      throw error;
    }
  },

  // Send property recommendation to guest
  sendRecommendation: async (request: SendRecommendationRequest): Promise<void> => {
    try {
      console.log('Sending property recommendation:', request);
      
      const response: AxiosResponse = await api.post('/api/send-property-recommendation/', request);
      
      if (response.data.status !== 'success') {
        throw new Error(response.data.message || 'Failed to send recommendation');
      }
      
      console.log('Recommendation sent successfully');
    } catch (error) {
      console.error('Error sending property recommendation:', error);
      throw error;
    }
  },

  // Get list of all properties
  getProperties: async (): Promise<Property[]> => {
    try {
      console.log('Fetching properties');
      
      const response: AxiosResponse = await api.get('/api/properties/');
      
      if (!response.data.data?.properties) {
        console.error('Invalid response format:', response.data);
        throw new Error('Invalid properties response format from API');
      }
      
      return response.data.data.properties;
    } catch (error) {
      console.error('Error fetching properties:', error);
      throw error;
    }
  }
};

export default propertyService; 